import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../../AppStores";
import {TabView} from "../../../widgets/tab/TabView";
import {TabChild} from "../../../widgets/tab/TabChild";
import type {XyiconFeature} from "../../../../generated/api/base";
import type {AppState} from "../../../../data/state/AppState";
import {typesFeatures} from "../../../../data/state/AppStateConstants";
import {StringUtils} from "../../../../utils/data/string/StringUtils";
import {SettingsModuleNav, SettingsModuleSubNav} from "../../../../Enums";
import {NavigationSettings} from "./navigation/NavigationSettings";
import {TypeSettings} from "./type/TypeSettings";
import {FieldSettings} from "./field/FieldSettings";
import {LayoutSettings} from "./layout/LayoutSettings";

interface IModuleSettingsProps {
	readonly feature: XyiconFeature;
	readonly appState?: AppState;
	readonly icon?: string;
}

@withAppStores("appState")
@observer
export class ModuleSettings extends React.Component<IModuleSettingsProps, {}> {
	private onChangeSettingsTab = (id: string) => {
		const parts = StringUtils.decomposeParts(location.hash).map((part) => part.value);

		parts[5] = id;
		const hash = parts.join("/");

		this.props.appState.app.navigation.go(hash);
	};

	private forceUpdateArrow = () => {
		this.forceUpdate();
	};

	public override componentDidMount() {
		window.addEventListener("hashchange", this.forceUpdateArrow);
	}

	public override componentWillUnmount() {
		window.removeEventListener("hashchange", this.forceUpdateArrow);
	}

	public override render() {
		const {feature, icon, appState} = this.props;
		const typesFeature = typesFeatures[feature as XyiconFeature.XyiconCatalog] || feature;

		let activeTab: SettingsModuleSubNav = location.hash.split("/").pop() as SettingsModuleSubNav;

		if (!Object.values(SettingsModuleSubNav).includes(activeTab)) {
			activeTab = SettingsModuleSubNav.TYPES;
			const hashArr = location.hash.split("/");
			const lastBit = hashArr.pop() as SettingsModuleNav;
			if (Object.values(SettingsModuleNav).includes(lastBit)) {
				hashArr.push(lastBit); // re-add it, because it's needed in this case
			}
			hashArr.push(activeTab);
			this.props.appState.app.navigation.go(hashArr.join("/"), true);
		}

		return (
			// key makes sure that when the user switches to another feature, new component instance will be recreated
			// with a fresh state, so eg. when the user is creating a type, and switches to another feature,
			// the CreateTypePanel will not be visible anymore.
			<div
				key={feature}
				className="ModuleSettings"
			>
				<TabView
					className="settingsTab"
					selectedTabId={activeTab}
					onChangeSelectedTabId={this.onChangeSettingsTab}
					icon={icon}
				>
					<TabChild
						id={SettingsModuleSubNav.TYPES}
						label="Types"
						title="Types"
					>
						<TypeSettings
							feature={feature}
							typesFeature={typesFeature}
						/>
					</TabChild>
					<TabChild
						id={SettingsModuleSubNav.FIELDS}
						label="Fields"
						title="Fields"
					>
						<FieldSettings
							feature={feature}
							typesFeature={typesFeature}
						/>
					</TabChild>
					<TabChild
						id={SettingsModuleSubNav.LAYOUTS}
						label="Layouts"
						title="Layouts"
					>
						<LayoutSettings
							ref={appState.layoutSettings as React.Ref<LayoutSettings>}
							feature={feature}
						/>
					</TabChild>
					{/* <TabChild id="maps" label="Google Maps" title="Google Maps">
					</TabChild> */}
					<TabChild
						id={SettingsModuleSubNav.NAVIGATION}
						label="Navigation"
						title="Navigation"
					>
						<NavigationSettings feature={feature} />
					</TabChild>
				</TabView>
			</div>
		);
	}
}
